import { LiveSocket } from "phoenix_live_view"

// LiveView 1.2 reloads on a normal WebSocket close (1000), which Bandit can
// send during shutdown. Keep the existing DOM for form auto-recovery instead.
// This override of an internal LiveView method needs checking on upgrades.
export default class ReconnectingLiveSocket extends LiveSocket {
  reloadWithJitter(view, log) {
    if (!this.getSocket().isConnected() && !this.hasPendingLink()) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = setTimeout(() => {
        this.reconnectTimer = null
        const socket = this.getSocket()
        if (socket.isConnected()) return
        // Phoenix keeps a reference to a normally closed transport. Tear it
        // down before connecting, while retaining LiveView channels and DOM.
        socket.disconnect(() => socket.connect())
      }, 1_000)
      return
    }

    // Connected mount failures and navigation still use LiveView’s fallback.
    // Authentication redirects are handled separately by LiveView as usual.
    super.reloadWithJitter(view, log)
  }

  disconnect(callback) {
    clearTimeout(this.reconnectTimer)
    this.reconnectTimer = null
    super.disconnect(callback)
  }
}
